import React from 'react';
import Section from '../common/Section';
import styles from '../../styles/modules/components/common-protection-plan.module.scss';
import ProtectionPlanCard from '../../components/commom-pages/ProtectionPlanCard';


interface PlanDetails {
    plans: {
        title: string,
        url: string,
        data: any
    }[],
    colomn?: any,
    router: any,
}

const ProtectionCardWithBanner = (props: PlanDetails) => {
    return (
        <Section>
            <div className={styles.selection}>
                <div className={`container ${styles.card_holder}`}>
                    <div className="row">
                        {props.plans && props.plans.map((item, index) => <ProtectionPlanCard key={index} colomn={props.colomn} title={item.title} url={item.url} data={item.data} router={props.router} />)}
                    </div>
                </div>
            </div>
        </Section>
    )
}

export default ProtectionCardWithBanner
